import Swiper from "swiper/bundle";

const initializeSlider = (cardsSliderWrapper) => {
  const cardsSlider = cardsSliderWrapper.querySelector(".cards-slider__slider");

  const sliderContainer = cardsSliderWrapper.querySelector(".cards-slider__slider-container");
  const slides = [...cardsSlider.querySelectorAll('.swiper-slide')];
  
  const nextBtn = cardsSliderWrapper.querySelector(".cards-slider__btn-next");
  const prevBtn = cardsSliderWrapper.querySelector(".cards-slider__btn-prev");
  const pagination = cardsSliderWrapper.querySelector(".cards-slider__pagination");

  const minSlidesForMobile = 1;
  const minSlidesForTablet = 2;
  const minSlidesForDesktop = 3;
      
  const shouldInitializeSlider = (window.innerWidth < 768 && slides.length > minSlidesForMobile) ||
                                 (window.innerWidth < 1024 && window.innerWidth >= 768 && slides.length > minSlidesForTablet) ||
                                 (window.innerWidth >= 1024 && slides.length > minSlidesForDesktop);
  
  if (!shouldInitializeSlider) {
    nextBtn.classList.add("d-none");
    prevBtn.classList.add("d-none");
    pagination.classList.add("d-none");
    sliderContainer.style.padding = "0";
  } else {
    nextBtn.classList.remove("d-none");
    prevBtn.classList.remove("d-none");
    pagination.classList.remove("d-none");

    new Swiper(cardsSlider, {
      lazy: true,
      slidesPerView: "auto",
      spaceBetween: 16,
      loop: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
      breakpoints: {
        768: {
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  }
};

const CardsSlider = () => {
  const cardsSliderWrappers = [...document.querySelectorAll('.cards-slider__slider-wrapper')];

  if (cardsSliderWrappers.length > 0) {
    cardsSliderWrappers.forEach(cardsSliderWrapper => {
      initializeSlider(cardsSliderWrapper);
    });

    window.addEventListener('resize', () => {
      cardsSliderWrappers.forEach((cardsSliderWrapper) => {
        const slider = cardsSliderWrapper.querySelector('.cards-slider__slider');
        if (slider.swiper) {
          slider.swiper.destroy(true, true);
        }
        initializeSlider(cardsSliderWrapper);
      });
    });
  }
};

export default CardsSlider;



// import Swiper from "swiper/bundle";

// const initializeSlider = (cardsSliderWrapper) => {
//   const cardsSlider = cardsSliderWrapper.querySelector(".cards-slider__slider");

//   const sliderContainer = cardsSliderWrapper.querySelector(".cards-slider__slider-container");
//   const slides = [...cardsSlider.querySelectorAll('.swiper-slide')];
  
//   const nextBtn = cardsSliderWrapper.querySelector(".cards-slider__btn-next");
//   const prevBtn = cardsSliderWrapper.querySelector(".cards-slider__btn-prev");
//   const pagination = cardsSliderWrapper.querySelector(".cards-slider__pagination");

//   const minSlidesForMobile = 1;
//   const minSlidesForTablet = 2;
//   const minSlidesForDesktop = 3;
      
//   const shouldInitializeSlider = (window.innerWidth < 768 && slides.length > minSlidesForMobile) ||
//                                  (window.innerWidth < 1024 && window.innerWidth >= 768 && slides.length > minSlidesForTablet) ||
//                                  (window.innerWidth >= 1024 && slides.length > minSlidesForDesktop);
  
//   if (!shouldInitializeSlider) {
//     nextBtn.classList.add("d-none");
//     prevBtn.classList.add("d-none");
//     pagination.classList.add("d-none");
//     sliderContainer.style.padding = "0";
//   } else {
//     nextBtn.classList.remove("d-none");
//     prevBtn.classList.remove("d-none");
//     pagination.classList.remove("d-none");

//     new Swiper(cardsSlider, {
//       lazy: true,
//       slidesPerView: "auto",
//       spaceBetween: 16,
//       loop: true,
//       navigation: {
//         nextEl: nextBtn,
//         prevEl: prevBtn,
//       },
//       pagination: {
//         el: pagination,
//         clickable: true,
//       },
//       breakpoints: {
//         768: {
//           spaceBetween: 24,
//         },
//         1024: {
//           slidesPerView: 3,
//         },
//       },
//     });
//   }
// };

// const CardsSlider = () => {
//   const cardsSliderWrappers = [...document.querySelectorAll('.cards-slider__slider-wrapper')];

//   if (cardsSliderWrappers.length > 0) {
//     const observerOptions = {
//       root: document,
//       rootMargin: "100% 0px 100% 0px", 
//     };

//     const observer = new IntersectionObserver((entries, observer) => {
//       entries.forEach(entry => {
//         if (entry.isIntersecting) {
//           initializeSlider(entry.target);
//           observer.unobserve(entry.target); 
//         }
//       });
//     }, observerOptions);

//     cardsSliderWrappers.forEach(cardsSliderWrapper => {
//       observer.observe(cardsSliderWrapper);
//     });

//     window.addEventListener('resize', () => {
//       cardsSliderWrappers.forEach((cardsSliderWrapper) => {
//         const slider = cardsSliderWrapper.querySelector('.cards-slider__slider');
//         if (slider.swiper) {
//           slider.swiper.destroy(true, true);
//         }
//         initializeSlider(cardsSliderWrapper);
//       });
//     });
//   }
// };

// export default CardsSlider;
